/**
 * Icon path data — ADR-20260917-3qv1.
 *
 * Every glyph is H2's own (`ds-icon/frp-icon.js`, Material geometry), so the built icons match
 * the handover path for path. Inline SVG path constants, no `@mui/icons-material` dependency and no
 * other new dependency. Every path is 24x24 viewBox, single-colour,
 * `fill="currentColor"`. This module holds only the data; `components/Icon.tsx`
 * is the rendered component.
 */

// ADR-20261016-v6nd (AC-2's "section-list card and timeline"): "check" and
// "person" extend the portal's own icon override (DESIGN-SYSTEM-DEPARTURES.md
// "ds-icon/frp-icon.js ... supplies the icon set the portal uses") with the two
// glyphs H2's section-list timeline marker needs (a completed section's
// checkmark, an assigned section's person) -- the portal's own icon set was
// always meant to grow with what the portal needs; the design system itself
// ships none.
export const ICON_NAMES = ["checkCircle", "chevronLeft", "help", "calendar", "shield", "check", "person"] as const;

export type IconName = (typeof ICON_NAMES)[number];

export const ICON_PATHS: Readonly<Record<IconName, string>> = {
  checkCircle:
    "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
  chevronLeft: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z",
  // H2 `ds-icon/frp-icon.js`: Material `help_outline`, the ring with a question mark.
  help: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z",
  calendar:
    "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z",
  shield:
    "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z",
  check: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
  person:
    "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
};
